





































































































































































































































import Vue from 'vue'
import Modal from '@/pmd/components/common/Modal.vue'
import { Location } from '@/models'
import SelectCmsModal from './SelectCmsModal.vue'
import ChatWidgetStep from './ChatWidgetStep.vue'
import { TextWidgetSettings } from '@/models/location'
import axios from 'axios'
import config from '@/config'
import { trackGaEvent } from '@/util/helper'
const DEPLOYMENT_BASE_URL = 'https://widgets.leadconnectorhq.com/' // for staging 'https://storage.googleapis.com/staging-leadconnector/'
const DEFAULT_AVATAR_IMAGE = `${DEPLOYMENT_BASE_URL}chat-widget/assets/defaultAvatar.png`
const TEXT_WIDGET_DEPLOYMENT = `${DEPLOYMENT_BASE_URL}loader.js`
const TEXT_WIDGET_IE_DEPLOYMENT = `${DEPLOYMENT_BASE_URL}chat-widget/loader.js`
const DEFAULT_LEGAL_MESSAGE =
  'By submitting you agree to receive SMS or e-mails for the provided channel. Rates may be applied.'
const DEFAULT_REVISIT_MSG = 'Welcome back {{name}}, How can we help you today?'
const DEFAULT_HEADING = 'Have a question?'
const DEFAULT_SUB_HEADING =
  'Enter your question below and a representative will get right back to you.'
const DEFAULT_SUCCESS_MESSAGE =
  'One of our representatives will contact you shortly.'
const DEFAULT_THANKS_MESSAGE = 'Thank You!'
const DEFAULT_PROMPT_MESSAGE = 'Hi there, have a question? Text us here.'
const NAME_VARIABLE = `{{name}}`
const INITIAL_DATA = {
  useEmailField: false,
  autoCountryCode: true,
  showPrompt: true,
  enableReturnUserMessage: true,
  enableMobileNumberValidation: true,
  headerText: 'Have a question?',
  subHeaderText:
    'Enter your question below and a representative will get right back to you.',
  legalMsg:
    'By submitting you agree to receive SMS or e-mails for the provided channel. Rates may be applied.',
  promptMsg: 'Hi there, have a question? Text us here.',
  successMsg: 'One of our representatives will contact you shortly.',
  returnUserMessage: `Welcome back ${NAME_VARIABLE}, How can we help you today?`,
  thankMsg: 'Thank You!',
  customerContact: '',
  countryCode: '',
  avatarImageUrl: DEFAULT_AVATAR_IMAGE,
}
export default Vue.extend({
  props: [
    'modalShow',
    'cms',
    'websiteScreenshot',
    'modalType',
    'cmsInstruction',
  ],
  components: {
    Modal,
    SelectCmsModal,
    ChatWidgetStep,
  },
  computed: {
    modalWidth() {
      return this.modalType === 'cms-select' ? 510 : 800
    },
  },
  data() {
    return {
      loaderScriptURL: TEXT_WIDGET_DEPLOYMENT,
      IELoaderScriptURL: TEXT_WIDGET_IE_DEPLOYMENT,
      widgetPrimaryColor: '#188bf6',
      widgetSettings: {} as TextWidgetSettings,
      currentLocationId: '',
      location: {} as Location,
      newCms: this.cms,
      currentStep: 0,
      showCopiedCodeToolTip: false,
      sending: false,
      email: '',
      chatIntegrated: undefined,
      currentStepInstruction: undefined,
      requestSend: false,
      chatWidgetTestDone: false,
      name_variable: NAME_VARIABLE,
      ...INITIAL_DATA,
      website: undefined,
    }
  },
  async mounted() {
    await this.fetchData()
    if (this.cms) {
      this.newCms = this.cms
    }
    this.$root.$on('set-cms', (data: any) => {
      this.newCms = data
      this.chatIntegrated = undefined
      this.currentStep = 0
      this.chatWidgetTestDone = false
    })
  },
  watch: {
    cms: async function () {
      this.newCms = this.cms
      this.currentStep = 0
      this.chatIntegrated = undefined
      this.chatWidgetTestDone = false
    },
    '$route.params.location_id': async function (id) {
      this.currentLocationId = id
      await this.fetchData()
      Object.assign(this.$data, INITIAL_DATA)
    },
  },
  methods: {
    changeModalView(type: string) {
      this.$root.$emit('modal-type', type)
    },
    async fetchData() {
      this.currentLocationId = this.$router.currentRoute.params.location_id
      this.location = new Location(
        await this.$store.dispatch(
          'locations/getCurrentLocation',
          this.currentLocationId
        )
      )
      this.widgetSettings = this.location.settings.textwidget
      this.headerText = this.widgetSettings.heading || this.headerText
      this.useEmailField =
        typeof this.widgetSettings.useEmailField === 'boolean'
          ? this.widgetSettings.useEmailField
          : this.useEmailField
      this.autoCountryCode =
        typeof this.widgetSettings.autoCountryCode === 'boolean'
          ? this.widgetSettings.autoCountryCode
          : this.autoCountryCode
      this.showPrompt =
        typeof this.widgetSettings.showPrompt === 'boolean'
          ? this.widgetSettings.showPrompt
          : this.showPrompt
      this.enableReturnUserMessage =
        typeof this.widgetSettings.enableRevisitMessage === 'boolean'
          ? this.widgetSettings.enableRevisitMessage
          : this.enableReturnUserMessage
      this.subHeaderText = this.widgetSettings.subHeading || this.subHeaderText
      this.legalMsg = this.widgetSettings.legalMsg || this.legalMsg
      this.promptMsg = this.widgetSettings.promptMsg || this.promptMsg
      this.successMsg = this.widgetSettings.successMsg || this.successMsg
      this.returnUserMessage =
        this.widgetSettings.revisitPromptMsg || this.returnUserMessage
      this.thankMsg = this.widgetSettings.thankYouMsg || this.thankMsg
      this.customerContact =
        this.widgetSettings.supportContact || this.customerContact
      this.countryCode = this.widgetSettings.countryCode || this.countryCode
      this.avatarImageUrl =
        this.widgetSettings.promptAvatar || this.avatarImageUrl
      this.widgetPrimaryColor =
        this.widgetSettings.widgetPrimaryColor || this.widgetPrimaryColor
      if (!Object.keys(this.widgetSettings).length) {
        console.log('Assigning Chat Object')
        Object.assign(this.widgetSettings, {
          heading: this.headerText,
          useEmailField: this.useEmailField,
          autoCountryCode: this.autoCountryCode,
          showPrompt: this.showPrompt,
          enableRevisitMessage: this.enableReturnUserMessage,
          subHeading: this.subHeaderText,
          legalMsg: this.legalMsg,
          promptMsg: this.promptMsg,
          successMsg: this.successMsg,
          revisitPromptMsg: this.returnUserMessage,
          thankYouMsg: this.thankMsg,
          supportContact: this.customerContact,
          countryCode: this.countryCode,
          promptAvatar: this.avatarImageUrl,
          widgetPrimaryColor: this.widgetPrimaryColor,
        })
      }
    },
    closeModal() {
      this.chatIntegrated = undefined
      this.chatWidgetTestDone = false
      this.requestSend = false
      this.currentStep = 0
      if (this.cms) {
        this.currentStepInstruction = this.cmsInstruction.steps[
          this.currentStep
        ]
      }
      this.$root.$emit('close-modal')
    },
    changeCms() {
      this.changeModalView('cms-select')
    },
    startInstalling() {
      if (this.newCms) {
        this.currentStep = 0
        this.currentStepInstruction = this.cmsInstruction.steps[
          this.currentStep
        ]
        this.changeModalView('steps')
      }
    },
    nextStep() {
      this.currentStep += 1
      this.currentStepInstruction = this.cmsInstruction.steps[this.currentStep]
    },
    prevStep() {
      this.currentStep -= 1
      this.currentStepInstruction = this.cmsInstruction.steps[this.currentStep]
      this.chatIntegrated = undefined
      this.chatWidgetTestDone = false
    },
    async sendInstructionsMail() {
      this.chatIntegrated = undefined
      this.changeModalView('send-instructions')
    },
    getScriptCode() {
      const elementName = 'chat-widget'
      const script = 'script'
      const attrPrefix = ''
      const revisitMessage = this.widgetSettings.revisitPromptMsg
      const importScriptCode = `<${script} src="${this.loaderScriptURL}"
          data-resources-url="${this.IELoaderScriptURL}" ></${script}>`
      let scriptCode = `    <${elementName}
            data-chat-widget
            ${attrPrefix}style="--chat-widget-primary-color: ${
        this.widgetPrimaryColor
      }; --chat-widget-active-color:${
        this.widgetPrimaryColor
      } ;--chat-widget-bubble-color: ${this.widgetPrimaryColor}"
            ${attrPrefix}location-id="${this.currentLocationId}"            
            ${attrPrefix}heading="${this.widgetSettings.heading}"
            ${attrPrefix}sub-heading="${this.widgetSettings.subHeading}"
            ${attrPrefix}prompt-msg="${this.widgetSettings.promptMsg}"
            ${attrPrefix}legal-msg="${this.widgetSettings.legalMsg}"
            ${attrPrefix}show-prompt="${this.widgetSettings.showPrompt}"
            ${attrPrefix}use-email-field="${this.widgetSettings.useEmailField}"
            ${attrPrefix}enable-revisit-message="${
        this.widgetSettings.enableRevisitMessage
      }"
            ${attrPrefix}revisit-prompt-msg="${revisitMessage}"
            ${attrPrefix}support-contact="${this.widgetSettings.supportContact}"
            ${attrPrefix}success-msg="${this.widgetSettings.successMsg}"
            ${attrPrefix}thank-you-msg="${this.widgetSettings.thankYouMsg}"
            ${attrPrefix}prompt-avatar="${this.widgetSettings.promptAvatar}"
            ${attrPrefix}auto-country-code="${
        this.widgetSettings.autoCountryCode
      }"
            ${attrPrefix}country-code="${
        this.widgetSettings.countryCode ? this.widgetSettings.countryCode : 'US'
      }"
      ></${elementName}>
       ${importScriptCode}`
      // for staging server-u-r-l="https://highlevel-staging.uc.r.appspot.com/"
      let startIndex = scriptCode.indexOf('data-chat-widget')
      let endIndex = scriptCode.indexOf('\n', startIndex)
      scriptCode = scriptCode.replace(
        scriptCode.substring(startIndex, endIndex + 13),
        ''
      )
      if (
        DEFAULT_PROMPT_MESSAGE === this.widgetSettings.promptMsg ||
        !this.widgetSettings.showPrompt
      ) {
        let startIndex = scriptCode.indexOf(`${attrPrefix}prompt-msg="`)
        let endIndex = scriptCode.indexOf('\n', startIndex)
        scriptCode = scriptCode.replace(
          scriptCode.substring(startIndex, endIndex + 13),
          ''
        )
      }
      if (DEFAULT_HEADING === this.widgetSettings.heading) {
        let startIndex = scriptCode.indexOf(`${attrPrefix}heading="`)
        let endIndex = scriptCode.indexOf('\n', startIndex)
        scriptCode = scriptCode.replace(
          scriptCode.substring(startIndex, endIndex + 13),
          ''
        )
      }
      if (DEFAULT_SUB_HEADING === this.widgetSettings.subHeading) {
        let startIndex = scriptCode.indexOf(`${attrPrefix}sub-heading="`)
        let endIndex = scriptCode.indexOf('\n', startIndex)
        scriptCode = scriptCode.replace(
          scriptCode.substring(startIndex, endIndex + 13),
          ''
        )
      }
      if (
        this.widgetSettings.enableRevisitMessage ||
        !this.widgetSettings.showPrompt
      ) {
        let startIndex = scriptCode.indexOf(
          `${attrPrefix}enable-revisit-message="`
        )
        let endIndex = scriptCode.indexOf('\n', startIndex)
        scriptCode = scriptCode.replace(
          scriptCode.substring(startIndex, endIndex + 13),
          ''
        )
        if (
          DEFAULT_REVISIT_MSG === this.widgetSettings.revisitPromptMsg ||
          !this.widgetSettings.showPrompt
        ) {
          startIndex = scriptCode.indexOf(`${attrPrefix}revisit-prompt-msg="`)
          endIndex = scriptCode.indexOf('\n', startIndex)
          scriptCode = scriptCode.replace(
            scriptCode.substring(startIndex, endIndex + 13),
            ''
          )
        }
      } else {
        const startIndex = scriptCode.indexOf(
          `${attrPrefix}revisit-prompt-msg="`
        )
        const endIndex = scriptCode.indexOf('\n', startIndex)
        scriptCode = scriptCode.replace(
          scriptCode.substring(startIndex, endIndex + 13),
          ''
        )
      }
      if (this.widgetSettings.legalMsg === DEFAULT_LEGAL_MESSAGE) {
        const startIndex = scriptCode.indexOf(`${attrPrefix}legal-msg="`)
        const endIndex = scriptCode.indexOf('\n', startIndex)
        scriptCode = scriptCode.replace(
          scriptCode.substring(startIndex, endIndex + 13),
          ''
        )
      }
      if (this.widgetSettings.showPrompt) {
        const startIndex = scriptCode.indexOf(`${attrPrefix}show-prompt="`)
        const endIndex = scriptCode.indexOf('\n', startIndex)
        scriptCode = scriptCode.replace(
          scriptCode.substring(startIndex, endIndex + 13),
          ''
        )
      }
      if (!this.widgetSettings.useEmailField) {
        const startIndex = scriptCode.indexOf(`${attrPrefix}use-email-field="`)
        const endIndex = scriptCode.indexOf('\n', startIndex)
        scriptCode = scriptCode.replace(
          scriptCode.substring(startIndex, endIndex + 13),
          ''
        )
      }
      if (!this.widgetSettings.supportContact) {
        const startIndex = scriptCode.indexOf(`${attrPrefix}support-contact="`)
        const endIndex = scriptCode.indexOf('\n', startIndex)
        scriptCode = scriptCode.replace(
          scriptCode.substring(startIndex, endIndex + 13),
          ''
        )
      }
      if (
        !this.widgetSettings.successMsg ||
        DEFAULT_SUCCESS_MESSAGE === this.widgetSettings.successMsg
      ) {
        const startIndex = scriptCode.indexOf(`${attrPrefix}success-msg="`)
        const endIndex = scriptCode.indexOf('\n', startIndex)
        scriptCode = scriptCode.replace(
          scriptCode.substring(startIndex, endIndex + 13),
          ''
        )
      }
      if (
        !this.widgetSettings.thankYouMsg ||
        DEFAULT_THANKS_MESSAGE === this.widgetSettings.thankYouMsg
      ) {
        const startIndex = scriptCode.indexOf(`${attrPrefix}thank-you-msg="`)
        const endIndex = scriptCode.indexOf('\n', startIndex)
        scriptCode = scriptCode.replace(
          scriptCode.substring(startIndex, endIndex + 13),
          ''
        )
      }
      if (
        !this.widgetSettings.promptAvatar ||
        !this.widgetSettings.showPrompt
      ) {
        const startIndex = scriptCode.indexOf(`${attrPrefix}prompt-avatar="`)
        const endIndex = scriptCode.indexOf('\n', startIndex)
        scriptCode = scriptCode.replace(
          scriptCode.substring(startIndex, endIndex + 13),
          ''
        )
      }
      if (this.widgetSettings.autoCountryCode) {
        let startIndex = scriptCode.indexOf(`${attrPrefix}auto-country-code="`)
        let endIndex = scriptCode.indexOf('\n', startIndex)
        scriptCode = scriptCode.replace(
          scriptCode.substring(startIndex, endIndex + 13),
          ''
        )
        startIndex = scriptCode.indexOf(`${attrPrefix}country-code="`)
        endIndex = scriptCode.indexOf('"', startIndex)
        scriptCode = scriptCode.replace(
          scriptCode.substring(startIndex, endIndex + 4),
          ''
        )
      }
      return scriptCode
    },
    async sendEmail() {
      let result = await this.$validator.validateAll('form-widgetcode.email')
      console.log(result)
      if (!result) {
        return false
      }
      this.sending = true
      try {
        const script = this.getScriptCode()
        await this.$http.post('/chat/send_instructions', {
          email: this.email,
          script,
          location_id: this.location.id,
          cms: this.newCms,
        })
        this.requestSend = true
        this.email = ''
        await this.$validator.reset();
        trackGaEvent(
          'Launchpad',
          'Sent WebChat Widget Instructions',
          `WebChat widget instructions mail has been sent for location: ${this.currentLocationId}`
        )
      } catch (err) {}
      this.sending = false
    },
    async testWidgetIntegration() {
      this.sending = true
      try {
        this.website = this.location.website
        window.addEventListener(
          'message',
          e => {
            if(e.data === 'LC_chatWidgetLoaded') {
              console.log('Chat Widget Loaded')
              this.chatIntegrated = true
              trackGaEvent(
                'Launchpad',
                'WebChat Widget Integrated',
                `WebChat Widget has been integrated for location: ${this.currentLocationId}`
              )
            }
          },
          false,
        );
        let count = 0
        const chatWidgetCheckingInterval = setInterval(async() => {
          count += 1
          if (this.chatIntegrated) { 
            await this.location.ref.update({
              is_chat_widget_integrated: true,
            })
            this.location = new Location(
              await this.$store.dispatch(
                'locations/getCurrentLocation',
                this.currentLocationId
              )
            )
            this.chatWidgetTestDone = true
            this.sending = false
            clearInterval(chatWidgetCheckingInterval)
            setTimeout(() => {
              this.closeModal()
            }, 8000)
            this.$root.$emit('chat-integrated')
          } 
          if (count > 12) {
            this.chatIntegrated = false
            this.chatWidgetTestDone = true
            this.sending = false
            clearInterval(chatWidgetCheckingInterval)
          }
        }, 5000)
      } catch (error) {
        this.chatIntegrated = false
        this.chatWidgetTestDone = true
        this.sending = false
        console.log(error)
      }
      
    },
  },
})
